/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Classification_Template_Sql_LabelInputs */

const en_classification_template_sql_label = /** @type {(inputs: Classification_Template_Sql_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SQL query`)
};

const nl_classification_template_sql_label = /** @type {(inputs: Classification_Template_Sql_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SQL-query`)
};

/**
* | output |
* | --- |
* | "SQL query" |
*
* @param {Classification_Template_Sql_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const classification_template_sql_label = /** @type {((inputs?: Classification_Template_Sql_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Classification_Template_Sql_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_classification_template_sql_label(inputs)
	return en_classification_template_sql_label(inputs)
});